import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { browserHistory, Link } from 'react-router';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { statusColours } from '../../constants/ColourConstants';

import DetailView from '../Common/DetailView';
import Markdown from 'react-markdown';

import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import HistoryIcon from 'material-ui/svg-icons/action/history';

import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LaunchIcon from 'material-ui/svg-icons/action/launch';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import DocumentIcon from 'material-ui/svg-icons/action/description';
import ImageIcon from 'material-ui/svg-icons/image/image';
import AssetIcon from 'material-ui/svg-icons/editor/insert-drive-file';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import AudioIcon from 'material-ui/svg-icons/av/library-music';

import AssetStore from '../../stores/AssetStore';
import { deleteAsset, editAsset, getAsset } from '../../actions/AssetActionCreator';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { DateStyles } from '../../constants/CentricConstants';
import { withId } from '../Common/Decorators';
import AssetEditDialog from './AssetEditDialog';

const getMenuItems = (id, onDelete, isText) => [
    {
        link: `/cent/asset/${id}/download`,
        target: '_blank',
        label: 'Download',
        icon: <DownloadIcon />,
        condition: {
            fields: {
                asAttachment: true
            }
        }
    },
    {
        link: `/dashboard/asset/${id}/history`,
        icon: <HistoryIcon />,
        label: 'History',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    { type: 'divider' },
    {
        link: `/dashboard/module/new/fromAsset/${id}`,
        icon: <LibraryIcon />,
        label: 'Export to Resource',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    {
        action: () => editAsset(id),
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            show: !isText,
            roles: [ROLES.ADMIN]
        }
    },
    {
        link: `/dashboard/asset/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            show: !!isText,
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: id,
        title: 'Delete',
        deleteAction: onDelete,
        message: (<span>Are you sure to delete this asset ? </span>),
        condition: {
            roles: [ROLES.ADMIN]
        }
    }
];


class Asset extends Component {

    componentWillMount() {
        this.menuItems = getMenuItems(this.props.id, this.onDelete);

    }
    componentDidMount() {
        getAsset(this.props.id);
    }

    render () {
        const { dateAdded, asAttachment } = this.state.details;
        const actions = buildContextMenu(getMenuItems(this.props.id, this.onDelete, !asAttachment), this.context.auth, this.state.details);
        let url, preview;


        const iconProps = {
            color: statusColours.default,
        };

        let avatarIcon = <AssetIcon {...iconProps}/>;

        switch (this.state.details.type) {

            case 'image':
                avatarIcon = <ImageIcon {...iconProps}/>;
                break;

            case 'text':
                avatarIcon = <SubjectIcon {...iconProps}/>;
                break;

            case 'document':
                avatarIcon = <DocumentIcon {...iconProps}/>;
                break;

            case 'e-learning':
                avatarIcon = <LaunchIcon {...iconProps}/>;
                break;

            case 'video':
                avatarIcon = <VideoIcon {...iconProps}/>;
                break;

            case 'audio':
                avatarIcon = <AudioIcon {...iconProps}/>;
                break;

            default:
                break;
        }


        if (asAttachment) {
            const { link } = this.state.details;
            if (!!link) {
                url = (<CardText>{this.state.details.filename}</CardText>);
                switch (this.state.details.type) {

                    case 'image':
                        preview = (
                            <CardText style={{textAlign: "center"}} >
                                <img style={{maxWidth: "95%"}} src={link} alt={this.state.details.filename} />
                            </CardText>
                        );
                        break;

                    default:
                        break;
                }
            }
        }

        return (
            <DetailView
                backButton={true}
                actions={actions}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={this.state.details.name}
                            subtitle={!!dateAdded && dateAdded.toLocaleString('en-GB', DateStyles.shortDateTime)}
                            avatar={avatarIcon}
                        />
                        <CardText className="cent-card-text">
                            <Markdown source={this.state.details.content || ''} />
                        </CardText>
                        {preview}
                        {url}
                    </Card>
                </div>
                <AssetEditDialog />
            </DetailView>
      );
    }

    onDelete(entityId) {
        if (entityId === this.props.id) {
            deleteAsset(entityId);
            browserHistory.goBack();
        }
    }


}

Asset.contextTypes = {
    auth: PropTypes.object.isRequired
};

Asset.getStores = () => ([AssetStore]);
Asset.calculateState = (prevState, {id}) => ({
    details: AssetStore.getById(id) || {}
});

export default withId(Container.create(Asset, {withProps: true}));
